module.exports = __webpack_public_path__ + "img/09_Wall to Floor.3ad51421.png";